import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";

import {
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import ClicksWithFtdCard from "./ClicksWithFtdCard";

const ClicksWithFtdItem = ({
  sortedData = [],
}: {
  sortedData?: Record<string, any>[];
}) => {
  if (!sortedData?.length) {
    return (
      <Box sx={{ mt: spacing.Spacing.xl.$value, textAlign: "center" }}>
        <Typography sx={{ fontSize: typography.Size.Text.sm.$value }}>
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
      <Stack spacing={2}>
        {sortedData.map((item, index) => (
          <ClicksWithFtdCard
            key={`${item.brand_id ?? "row"}-${index}`}
            brand_name={item.brand_name}
            brand_id={item.brand_id}
            click_out={item.click_out}
            table={item.table}
            link_name={item.link_name}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ClicksWithFtdItem;
